import BreadcrumbMenu from "../BreadcrumbMenu"

const ExerciseBreadcrumb = ({ activeDay, program }) => {
  
  const breadcrumbs = [
    { label: 'Home', link: '/home' },
    { label: `${program.name}`, link: `/program/${program?.id}` }
  ];

  // TODO: Handle this with day/week/programId logic

  if (activeDay) {
    breadcrumbs.push({ label: activeDay, link: '/assessment-timer', isActive: true });
  }
  return (
    <section className="welcome_002">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-12 col-lg-12 col-md-12">
            <BreadcrumbMenu
              breadcrumbs={breadcrumbs}
              classNames={"breadcrumb-block"}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default ExerciseBreadcrumb;
